/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { LoadingOutlined } from '@ant-design/icons';

import { useMimicTranslation } from '@/hooks/useMimicTranslation';
import { Text } from '@/primitives/Text';

import './SubtenantsHierarchy.css';

export function LoadingSubtenants() {
  const { t } = useMimicTranslation('subtenants');
  return (
    <div className="subtenant-placeholder">
      <Text>{t('subtenantLoading')}</Text>
      <LoadingOutlined />
    </div>
  );
}
